/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit/dist/createAction";
import { PREFIX } from "./const";
import initialState from "./initial";
import { IServiceState, IAuthState, ISession } from "./namespace";
import { communicationChannel, createPhaseAction } from "../../helpers/redux";

export const OAuthGosuslugi = createPhaseAction<undefined, string>(
  `${PREFIX}/oauth-gosuslugi`
);

export const VkAppVersion = createPhaseAction<undefined, string>(
  `${PREFIX}/vk-app-version`
);

export const AccessToken = createPhaseAction<undefined, string>(
  `${PREFIX}/auth-access-token`
);
export const RefreshToken = createPhaseAction<undefined, string>(
  `${PREFIX}/auth-refresh-token`
);

const reduxSlice = createSlice({
  name: PREFIX,
  initialState,
  reducers: {
    setInit(state: IServiceState, action: PayloadAction<boolean>) {
      state.isInit = action.payload;
    },
    setVkAppId(state: IServiceState, action: PayloadAction<string>) {
      state.settings.vk_app_id = action.payload;
    },
    setAuthState(state: IServiceState, action: PayloadAction<IAuthState>) {
      state.authState = action.payload;
    },
    setSession(state: IServiceState, action: PayloadAction<ISession>) {
      state.session = { ...action.payload };
    },
    setVkState(state: IServiceState, action: PayloadAction<string>) {
      state.vkState = action.payload;
    },
  },
  extraReducers: (builder) => {
    communicationChannel(OAuthGosuslugi, builder, "oauthGosuslugi");
    communicationChannel(VkAppVersion, builder, "vkAppVersion");
    communicationChannel(AccessToken, builder, "accessToken");
    communicationChannel(RefreshToken, builder, "refreshToken");
  },
});

const { reducer, actions } = reduxSlice;

export const {
  setInit,
  setVkAppId,
  setAuthState,
  setSession,
} = reduxSlice.actions;

export { reducer, actions };
